import { useNavigate, useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { useStoreActions } from 'easy-peasy';
import { toast } from 'react-toastify';

// import icons
import DeleteIcon from '../../../assets/images/svg/delete-icon.svg';
import AttentionIcon from '../../../assets/images/svg/attention.svg';

// import components
import Modal from '../Modal_2';

// tools
import { extractNumericQuantity } from '../../tools/manager';

// modèle data Material
const refMaterial = {
  idMaterial: '',
  name: '',
  reference: null,
  quantity: '',       // nombre pour le back
  quantityLabel: '',  // champ libre "3 u", "250 ml", etc.
};

// data fixes
const createName = 'Vétilla Zobda';
const supplierName = 'Sacarabany SARL';

const EditPrefillPurshaseOrder = () => {
  //  🌱🌱 init store(services)   🌱🌱
  const getSacaCompany = useStoreActions((actions) => actions.middleware.CompanyMiddleware.getSacaCompany);
  const getOrderCoupon = useStoreActions((actions) => actions.middleware.OrdersMiddleware.getOrderCouponById);
  const _deletePrefillCoupon = useStoreActions((actions) => actions.middleware.OrdersMiddleware.deletePrefillCoupon);
  const updateOrderCoupon = useStoreActions((actions) => actions.middleware.OrdersMiddleware.updateOrderCoupon);
  const getListMaterialSettings = useStoreActions(
    (actions) => actions.middleware.OrdersMiddleware.getListMaterialSettings
  );
  const deleteMaterialData = useStoreActions((actions) => actions.middleware.OrdersMiddleware.deleteMaterialData);
  const deletesMultipleMaterialsData = useStoreActions(
    (actions) => actions.middleware.OrdersMiddleware.deletesMultipleMaterialsData
  );

  // state (données)
  const [listeMaterialCreate, setListeMaterialCreate] = useState([{ ...refMaterial }]); // anciens matériaux
  const [newListeMaterialCreate, setNewListeMaterialCreate] = useState([]);             // nouveaux matériaux
  const [materials, setMaterials] = useState([]);
  const [referencesMaterials, setReferencesMaterials] = useState([]);
  const [orderCoupon, setOrderCoupon] = useState([]);
  const [deleteMaterialId, setDeleteMaterialId] = useState('');
  const [numberCoupon, setNumberCoupon] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showModalCoupon, setShowModalCoupon] = useState(false);
  const [idCoupon, setIdCoupon] = useState(null);
  const [idSaca, setIdSaca] = useState([]);
  const [formError, setformError] = useState(false);
  const { id, idWorksite } = useParams();

  useEffect(() => {
    setformError(false);
  }, [listeMaterialCreate, newListeMaterialCreate]);

  // navigate
  const navigate = useNavigate();

  // effect
  useEffect(() => {
    getOrderCouponById();
    callListMaterialSettings();
    callListSaca();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const addNewMaterial = (e) => {
    e.preventDefault();
    setNewListeMaterialCreate((prev) => [...prev, { ...refMaterial }]);
  };

  // --- helpers génériques pour update de ligne ---

  const updateExistingLine = (index, updater) => {
    setListeMaterialCreate((prev) => {
      const copy = [...prev];
      const line = { ...copy[index] };
      updater(line);
      copy[index] = line;
      return copy;
    });
  };

  const updateNewLine = (index, updater) => {
    setNewListeMaterialCreate((prev) => {
      const copy = [...prev];
      const line = { ...copy[index] };
      updater(line);
      copy[index] = line;
      return copy;
    });
  };

  // set value Material (ancien matériel)
  const changeValueMaterial = (index, key, value) => {
    updateExistingLine(index, (line) => {
      if (key === 'name') {
        const mat = referencesMaterials.find((el) => el.id === value);
        line.idMaterial = value;
        line.name = mat?.name || '';
        line.reference = null;
      } else if (key === 'quantityLabel') {
        const numeric = extractNumericQuantity(value);
        line.quantityLabel = value;
        line.quantity = numeric === '' ? '' : numeric;
      } else {
        line[key] = value;
      }
    });
  };

  // set value Material (nouveau matériel)
  const changeValueNewMaterial = (index, key, value) => {
    updateNewLine(index, (line) => {
      if (key === 'name') {
        const mat = referencesMaterials.find((el) => el.id === value);
        line.idMaterial = value;
        line.name = mat?.name || '';
        line.reference = null;
      } else if (key === 'quantityLabel') {
        const numeric = extractNumericQuantity(value);
        line.quantityLabel = value;
        line.quantity = numeric === '' ? '' : numeric;
      } else {
        line[key] = value;
      }
    });
  };

  // delete line new Material
  const deleteMaterial = (e, index) => {
    e.preventDefault();
    setNewListeMaterialCreate((prev) => prev.filter((_, i) => i !== index));
  };

  // delete Material Old
  const deleteOldMaterial = (e, index, id) => {
    e.preventDefault();
    setShowModal(true);
    setDeleteMaterialId(id);
  };

  //call list id saca
  const callListSaca = async () => {
    try {
      const res = await getSacaCompany();
      setIdSaca(res[0].id);
    } catch (error) {
      console.log('Error: ', error);
      toast.error('Une erreur est survenue lors de la récupération des informations');
      window.location.href = '/clients';
    }
  };

  // get order coupon by id
  const getOrderCouponById = async () => {
    try {
      const res = await getOrderCoupon(id);
      setNumberCoupon(res.numero);
      setOrderCoupon(res);

      const newData = res.materialData.items.map((items) => {
        const refs = items.materialSettings.references?.[0]?.reference || '';
        const refsArray = refs.split(',');
        return {
          ...items,
          id: items.id,
          name: items.materialSettings.name,
          reference: items.indexRef,
          refs: refsArray,
          idMaterial: items.materialSettings.id,
          quantity: items.quantity,
          quantityLabel:
            items.quantityLabel || (items.quantity != null ? String(items.quantity) : ''), // fallback pour anciens b/c
        };
      });
      setListeMaterialCreate(newData);
    } catch (error) {
      console.log('Error: ', error);
      toast.error('Une erreur est survenue lors de la récupération des informations');
      window.location.href = '/clients';
    }
  };

  // func delete coupon
  const deletePrefillCoupon = async () => {
    try {
      await _deletePrefillCoupon({ id: idCoupon });
      navigate(-1);
    } catch (error) {
      console.log('Error: ', error);
      toast.error('Une erreur est survenue lors de la suppression du bon pré-rempli');
    }
  };

  // func onClick delete coupon
  const handleDelete = (e, id) => {
    e.preventDefault();
    setIdCoupon(id);
    setShowModalCoupon(true);
  };

  // verif is all form not empty
  const isOkfrom = () => {
    if (!numberCoupon) return false;

    const checkLine = (line) => {
      if (!line.idMaterial) return false;
      if (line.reference === null || line.reference === '' || line.reference === undefined) return false;
      if (!line.quantityLabel || !line.quantityLabel.trim()) return false;

      const numeric = extractNumericQuantity(line.quantityLabel);
      if (numeric === '' || Number(numeric) <= 0) return false;

      return true;
    };

    for (const element of listeMaterialCreate) {
      if (!checkLine(element)) return false;
    }
    for (const item of newListeMaterialCreate) {
      if (!checkLine(item)) return false;
    }
    return true;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (isOkfrom()) {
      const newdata = {
        id: id,
        name: createName,
        supplierName,
        numero: numberCoupon,
        worksiteId: idWorksite,
        listeMaterialCreate,   // contient quantity + quantityLabel
        idSaca: idSaca,
        newListeMaterialCreate // idem
      };
      try {
        await updateOrderCoupon(newdata);
        navigate(-1);
      } catch (error) {
        console.log('Error: ', error);
        toast.error('Une erreur est survenue lors de la modification du bon pré-rempli');
      }
    } else {
      setformError(true);
    }
  };

  const navigateOrder = () => {
    navigate(-1);
  };

  //call list materialSettings
  const callListMaterialSettings = async () => {
    try {
      const res = await getListMaterialSettings();
      const data = res.filter((item) => item.name !== 'Climatiseur');
      setReferencesMaterials(data);
      setMaterials(data);
    } catch (error) {
      console.log('Error: ', error);
      toast.error('Une erreur est survenue lors de la récupération des informations');
      window.location.href = '/clients';
    }
  };

  const callDeleteMaterial = async (id) => {
    try {
      await deleteMaterialData({id: id});
      await getOrderCouponById();
    } catch (error) {
      console.log('Error: ', error);
      toast.error('Une erreur est survenue lors de la suppression des informations');
    }
  };

  const deleteCoupon = async () => {
    try {
      await deletesMultipleMaterialsData({ listMaterial: listeMaterialCreate });
      await deletePrefillCoupon();
      setShowModalCoupon(false);
    } catch (error) {
      console.log('Error: ', error);
      toast.error('Une erreur est survenue lors de la suppression des informations');
    }
  };

  return (
    <section>
      <div className="mt-14">
        <form onSubmit={onSubmit}>
          <div className="flex space-x-6 mx-14">
            <div className="flex flex-col space-y-4">
              <label>Nom du client</label>
              <input
                className="inputFocus w-[343px] inputPreFill text-blue-admin"
                type="text"
                placeholder="Nom du client"
                defaultValue={orderCoupon?.worksite?.company?.name}
                disabled
              />
            </div>
            <div className="flex flex-col space-y-4 ">
              <label>Nom du fournisseur</label>
              <input
                className="inputFocus inputPreFill w-[343px] text-blue-admin"
                type="text"
                placeholder="Sacarabany SARL"
                defaultValue={supplierName}
                disabled
              />
            </div>
            <div className="flex flex-col w-full space-y-4">
              <label>Numéro du bon</label>
              <input
                className="inputFocus inputPreFill text-blue-admin"
                type="number"
                defaultValue={orderCoupon?.numero}
                disabled
              />
            </div>
          </div>
          <div className="flex space-x-6 mx-14">
            <div className="flex flex-col mt-5 space-y-4 ">
              <label>Créer par</label>
              <input
                className="inputFocus inputPreFill w-[343px]  text-blue-admin"
                type="text"
                placeholder="Vétilla Zobda"
                defaultValue={createName}
                disabled
              />
            </div>
          </div>

          {/* div list */}
          <div className="mt-8 mx-14">
            <h4 className="font-semibold">Liste du matériel utilisé</h4>
            {listeMaterialCreate.map((materiel, index) => {
              const idMaterial = listeMaterialCreate[index].idMaterial;
              const referenceArray = referencesMaterials
                .find((el) => el.id === idMaterial)
                ?.references[0]?.reference?.split(',') || [];

              return (
                <div
                  key={materiel.id || index}
                  className="flex items-center mt-5 space-x-5"
                >
                  {/* Nom matériel (ancien) */}
                  <div className="flex flex-col space-y-3">
                    <label className="text-gray-placeholder">Nom du matériel</label>
                    <select
                      className="w-[234px] rounded-lg py-4 border-gray-separate text-blue-admin"
                      value={materiel.idMaterial || ''}
                      onChange={(e) => changeValueMaterial(index, 'name', e.target.value)}
                    >
                      <option value="" disabled>
                        Nom du matériel
                      </option>
                      {materials?.map((material) => (
                        <option
                          key={material.id}
                          value={material.id}
                        >
                          {material.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Référence (ancien) */}
                  <div className="flex flex-col space-y-3">
                    <label className="text-gray-placeholder">Référence</label>
                    <select
                      className="w-[234px] rounded-lg py-4 border-gray-separate text-blue-admin"
                      value={
                        listeMaterialCreate[index]?.reference === null
                          ? ''
                          : listeMaterialCreate[index]?.reference
                      }
                      onChange={(e) => changeValueMaterial(index, 'reference', e.target.value)}
                    >
                      <option disabled value="">
                        -
                      </option>
                      {referenceArray.map((referenceMaterial, ind) => (
                        <option
                          key={`${referenceMaterial}-${ind}`}
                          value={ind}
                        >
                          {referenceMaterial}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Quantité (ancien, champ libre) */}
                  <div className="flex flex-col space-y-3">
                    <label className="text-gray-placeholder">Quantité</label>
                    <input
                      className="max-w-[234px] rounded-lg py-4 border border-gray-separate placeholder:text-blue-admin text-blue-admin"
                      type="text"
                      placeholder="Ex : 3, 10 u, 250 ml"
                      value={materiel.quantityLabel || ''}
                      onChange={(e) => changeValueMaterial(index, 'quantityLabel', e.target.value)}
                    />
                  </div>

                  {/* bouton delete ancien */}
                  <div>
                    <button
                      onClick={(e) => deleteOldMaterial(e, index, materiel.id)}
                      className="w-8 p-2 border rounded-lg mt-7 border-white-admin"
                    >
                      <img
                        src={DeleteIcon}
                        alt="delete icon"
                      />
                    </button>
                  </div>
                </div>
              );
            })}
          </div>

          {/* 2nd table : nouveaux matériels */}
          <div className="mt-8 mx-14">
            <h4 className="font-semibold">Liste de nouveau matériel à ajouter</h4>
            {newListeMaterialCreate.map((materiel, index) => {
              const idMaterial = newListeMaterialCreate[index].idMaterial;
              const referenceArray = referencesMaterials
                .find((el) => el.id === idMaterial)
                ?.references[0]?.reference?.split(',') || [];

              return (
                <div
                  key={materiel.id || `new-${index}`}
                  className="flex items-center mt-5 space-x-5"
                >
                  {/* Nom du matériel (nouveau) */}
                  <div className="flex flex-col space-y-3">
                    <label className="text-gray-placeholder">Nom du matériel</label>
                    <select
                      className="w-[234px] rounded-lg py-4 border-gray-separate text-blue-admin"
                      value={materiel.idMaterial || ''}
                      onChange={(e) => changeValueNewMaterial(index, 'name', e.target.value)}
                    >
                      <option value="" disabled>
                        Nom du matériel
                      </option>
                      {materials?.map((material) => (
                        <option
                          key={material.id}
                          value={material.id}
                        >
                          {material.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Référence (nouveau) */}
                  <div className="flex flex-col space-y-3">
                    <label className="text-gray-placeholder">Référence</label>
                    <select
                      className="w-[234px] rounded-lg py-4 border-gray-separate text-blue-admin"
                      value={
                        newListeMaterialCreate[index]?.reference === null
                          ? ''
                          : newListeMaterialCreate[index]?.reference
                      }
                      onChange={(e) => changeValueNewMaterial(index, 'reference', e.target.value)}
                    >
                      <option disabled value="">
                        -
                      </option>
                      {referenceArray.map((referenceMaterial, refIndex) => (
                        <option
                          key={`${referenceMaterial}-${refIndex}`}
                          value={refIndex}
                        >
                          {referenceMaterial}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Quantité (nouveau, champ libre) */}
                  <div className="flex flex-col space-y-3">
                    <label className="text-gray-placeholder">Quantité</label>
                    <input
                      className="max-w-[234px] rounded-lg py-4 border border-gray-separate placeholder:text-blue-admin text-blue-admin"
                      type="text"
                      placeholder="Ex : 3, 10 u, 250 ml"
                      value={newListeMaterialCreate[index]?.quantityLabel || ''}
                      onChange={(e) => changeValueNewMaterial(index, 'quantityLabel', e.target.value)}
                    />
                  </div>

                  {/* bouton delete nouveau */}
                  <div>
                    <button
                      onClick={(e) => deleteMaterial(e, index)}
                      className="w-8 p-2 border rounded-lg mt-7 border-white-admin"
                    >
                      <img
                        src={DeleteIcon}
                        alt="delete icon"
                      />
                    </button>
                  </div>
                </div>
              );
            })}

            <button
              onClick={addNewMaterial}
              className="px-4 py-3 mt-6 text-sm font-semibold border rounded-lg bg-yellow-admin text-blue-admin"
            >
              + Ajouter un nouveau matériel
            </button>
          </div>

          {formError && <p className="text-red-error text-end mt-5">Veuillez remplir tous les champs!</p>}

          <div className="flex items-center justify-between py-4 mt-16 border-t border-white-admin">
            <button
              onClick={navigateOrder}
              className="border rounded-lg cursor-pointer ml-14 border-gray-admin px-5 py-3 text-blue-admin"
            >
              Annuler
            </button>
            <div>
              <button
                onClick={(e) => handleDelete(e, id)}
                className="px-5 py-3 font-semibold text-red-error rounded-lg cursor-pointer mr-5 border border-red-bg-error"
              >
                Supprimer ce bon pré-rempli
              </button>
              <button
                type="submit"
                className="px-5 py-3 font-semibold text-blue-admin rounded-lg cursor-pointer mr-14 bg-yellow-admin"
              >
                Enregistrer ce bon pré-rempli
              </button>
            </div>
          </div>
        </form>
      </div>

      {/* Modal suppression bon */}
      <Modal isVisible={showModalCoupon}>
        <div>
          <div className="pt-5 pl-5">
            <img
              src={AttentionIcon}
              alt="attention icon"
            />
            <p className="pl-5 pt-7">Supression du bon pré-rempli</p>
            <p className="px-5 pt-2 text-gray-admin">
              Êtes-vous sûr de vouloir supprimer ce bon ? Cette action est définitive.
            </p>
            <div className="text-center pt-7">
              <button
                className="px-12 py-3 mr-4 font-semibold border rounded-xl text-red-error"
                onClick={() => setShowModalCoupon(false)}
              >
                Annuler
              </button>
              <button
                onClick={deleteCoupon}
                className="px-10 py-3 text-white bg-red-error rounded-xl"
              >
                Supprimer
              </button>
            </div>
          </div>
        </div>
      </Modal>

      {/* Modal suppression matériel */}
      <Modal isVisible={showModal}>
        <div>
          <div className="pt-5 pl-5">
            <img
              src={AttentionIcon}
              alt="attention icon"
            />
            <p className="pl-5 pt-7">Supression du matériel</p>
            <p className="px-5 pt-2 text-gray-admin">
              Êtes-vous sûr de vouloir supprimer ce matériel ? Cette action est définitive.
            </p>
            <div className="text-center pt-7">
              <button
                className="px-12 py-3 mr-4 font-semibold border rounded-xl text-red-error"
                onClick={() => setShowModal(false)}
              >
                Annuler
              </button>
              <button
                onClick={() => {
                  setShowModal(false);
                  callDeleteMaterial(deleteMaterialId);
                }}
                className="px-10 py-3 text-white bg-red-error rounded-xl"
              >
                Supprimer
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </section>
  );
};

export default EditPrefillPurshaseOrder;
